import React, {
  useState,
  useEffect,
  useContext
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  VALIDATOR_EMAIL,
  VALIDATOR_REQUIRE,
} from '../../utils/validators';
import Input from '../../shared/component/FormElements/Input';
import Avatar from '../../shared/component/FormElements/Avatar';
import Button from '../../shared/component/FormElements/Button';
import { useForm } from '../../hooks/form-hook';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';

// Alerta
import Alerta from './Alerta';

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    height: 100,
    width: 100
  },
  button: {
    color: 'white'
  },
}));

const Profile = ({ className, ...rest }) => {
  const auth = useContext(AuthContext);
  const classes = useStyles();
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler] = useForm({
    email: {
      value: '',
      isValid: false
    },
    avatar: {
      value: '',
      isValid: true
    },
    nome: {
      value: '',
      isValid: false
    }
  }, false);
  const [perfil, setPerfil] = useState(false);
  const [salvou, setSalvou] = useState(false);
  console.log(perfil);
  useEffect(() => {
    const fetchPerfil = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/usuarios/perfil`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setPerfil(responseData.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchPerfil();
  }, [sendRequest, auth.token, auth.userPermission]);

  const perfilSubmitHandler = async (event) => {
    event.preventDefault();
    console.log('Inputs');
    console.log(formState.inputs);
    try {
      const formulario = new FormData();
      formulario.append('nome', formState.inputs.nome.value);
      formulario.append('email', formState.inputs.email.value);
      formulario.append('avatar', formState.inputs.avatar.value);
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/usuarios/perfil/`,
        'POST',
        formulario,
        {
          'x-access-token': auth.token
        }
      );
      if (response.sucesso) {
        setSalvou(true);
        auth.att(response.data.nome, response.data.avatar);
        // atualizar avatar se trocadado e infos do usuario logado.
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fechar = () => {
    setSalvou(false);
  };

  if (!perfil || isLoading) {
    return (
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={4}
          md={6}
          xs={12}
        >
          <LoadingSpinner asOverlay />
        </Grid>
      </Grid>
    );
  }

  return (
    <form onSubmit={perfilSubmitHandler}>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={4}
          md={6}
          xs={12}
        >
          <Card
            className={clsx(classes.root, className)}
            {...rest}
          >
            {perfil && (
              <CardContent>
                <Box
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                >
                  <Avatar
                    id="avatar"
                    name="avatar"
                    onInput={inputHandler}
                    validators={[]}
                    initialValue={perfil.avatar !== undefined ? `${process.env.REACT_APP_BACKEND_IMG}${perfil.avatar.caminho}` : ''}
                    initialValid
                    errorText="Insira o avatar do usuário."
                    extraClass={classes.avatar}
                  />
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    variant="h3"
                  >
                    {perfil.nome}
                  </Typography>
                  <Typography
                    className={classes.dateText}
                    color="textSecondary"
                    variant="body1"
                  >
                    {`${moment().format('hh:mm A')}`}
                  </Typography>
                </Box>
              </CardContent>
            )}
          </Card>
        </Grid>
        <Grid
          item
          lg={8}
          md={10}
          xs={12}
        >
          <Card>
            <CardHeader
              subheader="Atualize aqui suas informações pessoais."
              title="Perfil"
            />
            <Divider />
            {perfil && (
              <CardContent>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Grid container fullWidth spacing={3}>
                      <Grid item xs={6}>
                        <Input
                          id="nome"
                          element="input"
                          type="text"
                          label="Nome do Usuário"
                          fullWidth
                          validators={[VALIDATOR_REQUIRE()]}
                          errorText="Insira um nome."
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          initialValue={perfil.nome}
                          initialValid
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Input
                          id="email"
                          element="input"
                          type="email"
                          label="E-mail do Usuário"
                          fullWidth
                          validators={[VALIDATOR_EMAIL()]}
                          errorText="Insira um e-mail válido."
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          initialValue={perfil.email}
                          initialValid
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                  </Grid>
                </Grid>
              </CardContent>
            )}
            <Divider />
            <Box
              display="flex"
              justifyContent="flex-start"
              p={2}
            >
              <Button
                color="secondary"
                variant="contained"
                type="submit"
                className={classes.button}
                disabled={!formState.isValid}
              >
                Atualizar
              </Button>
            </Box>
          </Card>
        </Grid>
        <Grid
          item
          lg={4}
          md={6}
          xs={12}
        >
          <ErrorMessage error={error} onClear={clearError} />
        </Grid>
      </Grid>
      <Alerta open={salvou} close={fechar} tipo="success">Perfil atualizado com sucesso!</Alerta>
    </form>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
